export default "__VITE_ASSET__D8I0CeQ7__"